import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Section from '../shared/Section';
import SectionHeading from '../shared/SectionHeading';

const impactDescription =
  'FoodFe was founded on the principle of reducing food waste. By preparing meals based on confirmed demand, the platform supports Norway’s goal of cutting food waste by 50%, helping kitchens avoid overproduction and reduce waste at the source: making sustainability part of everyday operations.';

export const Together = () => {
  const togetherImage = `${process.env.PUBLIC_URL}/assets/food_image3.png`;
  return (
    <Section background='#FFFFFF'>
      <Grid container spacing={{ xs: 6, md: 10 }} alignItems='center'>
        <Grid item xs={12} md={6}>
          <Stack spacing={4}>
            <SectionHeading
              align='left'
              eyebrow='Impact'
              title='On Track to Cut Food Waste by 50%'
              description={impactDescription}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              width: { xs: '92%', md: '85%' },
              maxWidth: 480,
              mx: 'auto',
              borderRadius: 36,
              overflow: 'hidden',
              p: { xs: 2, md: 2.5 },
              background: 'linear-gradient(140deg, rgba(246,120,95,0.18) 0%, rgba(255,255,255,0.92) 100%)',
              boxShadow: '0px 30px 64px rgba(31, 36, 51, 0.18)',
            }}
          >
            <Box
              component='img'
              src={togetherImage}
              alt='People sharing a meal'
              sx={{
                width: '100%',
                height: { xs: 260, sm: 320, md: 360 },
                objectFit: 'cover',
                display: 'block',
                borderRadius: 28,
                boxShadow: '0px 18px 32px rgba(31, 36, 51, 0.14)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: 'inherit',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
};
